import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  { path: 'property', lazy: async () => ({ Component: (await import('./PropertyPage')).PropertyPage }) },
];
